import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingVideo } from 'ha/services/apiV2/types/Listing';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (listingId: number, videoId: number) =>
  makeCall<ListingVideo[]>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/video/${videoId}/confirm`,
  );
